import {
    FaYoutube,
    FaLinkedin,
    FaVideo,
    FaCode
}
from "react-icons/fa";

import playwright_pre_modules from "./npntraining/playwright_pre_modules.json"
import data_engineering_pre_modules from "./npntraining/data_engineering_pre_modules.json";
import npntraining_python from "./npntraining/python_programming.json";
import pythonp from "./npntraining/python.json"
import npntraining_java_for_backend_development from "./npntraining/java_for_backend_development.json";
import ai202603 from "./npntraining/ai_delivery_engineering.json"
import ai_engineering from "./npntraining/ai_engineering.json"


export const timer = {
    status: true,
    duration: 15 * 60,
    threshold: 5 * 60,
};
const config = import.meta.env.VITE_CONFIG || "npntraining";
console.log(config)
export const sessionDuration = 1000 * 60 * 60; // Default time 1 hour (in milliseconds)

export const coursesList = {
    101: {
        homePage:
        "https://docs.google.com/document/d/e/2PACX-1vRw2tdvwW_ZjY0Zt-qSos1Vhzm23hpwo7cNfcrp88LUK91tEUkmyan9CdJxcwMMkJoYxaE1fZIPIAmT/pub?embedded=true",                  
        expiryDate: "12/30/2026",
        moduleOverrideFirst :playwright_pre_modules,    
        globalTitles: {
            header: {
                logo: "/Logo.png",
                title: "NPN Training",
                courseTitle: "",
            },
            socialHandles: [{
                    id: "youtube",
                    url: "https://www.youtube.com/npntraining",
                    icon: FaYoutube,
                }, {
                    id: "linkedIn",
                    url: "https://www.linkedin.com/NPNTraining",
                    icon: FaLinkedin,
                }, {
                    id: "googlemeet",
                    url: "https://meet.google.com/uux-tpip-xqt",
                    icon: FaVideo,
                }, {
                    id: "code",
                    url: "https://codeshare.io/npntraining",
                    icon: FaCode,
                },
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} NPN Training PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by NPN Training",
            },
        },
    },202603: {
        homePage:
        "https://docs.google.com/document/d/e/2PACX-1vRw2tdvwW_ZjY0Zt-qSos1Vhzm23hpwo7cNfcrp88LUK91tEUkmyan9CdJxcwMMkJoYxaE1fZIPIAmT/pub?embedded=true",      
        plannerPage: "",
        askQuestionsPage: "",       
        courseWelcomePage:
        "https://docs.google.com/spreadsheets/d/1niPtHpF6u49iU__War8Zntm9_z930_76BQo7DpApxXY/edit?rm=minimal",
        expiryDate: "12/30/2026",
          
        globalTitles: {
            header: {
                logo: "/Logo.png",
                title: "NPN Training",
                courseTitle: "",
            },
            socialHandles: [{
                    id: "youtube",
                    url: "https://www.youtube.com/npntraining",
                    icon: FaYoutube,
                }, {
                    id: "linkedIn",
                    url: "https://www.linkedin.com/NPNTraining",
                    icon: FaLinkedin,
                }, {
                    id: "googlemeet",
                    url: "https://meet.google.com/uux-tpip-xqt",
                    icon: FaVideo,
                }, {
                    id: "code",
                    url: "https://codeshare.io/npntraining",
                    icon: FaCode,
                },
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} NPN Training PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by NPN Training",
            },
        },
    },
    202604: {
        homePage:
        "https://docs.google.com/document/d/e/2PACX-1vRw2tdvwW_ZjY0Zt-qSos1Vhzm23hpwo7cNfcrp88LUK91tEUkmyan9CdJxcwMMkJoYxaE1fZIPIAmT/pub?embedded=true",      
        plannerPage: "",       
        courseWelcomePage:
        "https://docs.google.com/spreadsheets/d/1niPtHpF6u49iU__War8Zntm9_z930_76BQo7DpApxXY/edit?rm=minimal",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :data_engineering_pre_modules,        
        globalTitles: {
            header: {
                logo: "/Logo.png",
                title: "NPN Training",
                courseTitle: "Comprehensive Python Programming",
            },
            socialHandles: [{
                    id: "youtube",
                    url: "https://www.youtube.com/npntraining",
                    icon: FaYoutube,
                }, {
                    id: "linkedIn",
                    url: "https://www.linkedin.com/NPNTraining",
                    icon: FaLinkedin,
                }, {
                    id: "googlemeet",
                    url: "https://meet.google.com/uux-tpip-xqt",
                    icon: FaVideo,
                }, {
                    id: "code",
                    url: "https://codeshare.io/npntraining",
                    icon: FaCode,
                },
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} NPN Training PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by NPN Training",
            },
        },
    },
    202605: {
        homePage:
        "https://docs.google.com/document/d/e/2PACX-1vRw2tdvwW_ZjY0Zt-qSos1Vhzm23hpwo7cNfcrp88LUK91tEUkmyan9CdJxcwMMkJoYxaE1fZIPIAmT/pub?embedded=true",      
        plannerPage: "",       
        courseWelcomePage:
        "https://docs.google.com/spreadsheets/d/1niPtHpF6u49iU__War8Zntm9_z930_76BQo7DpApxXY/edit?rm=minimal",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :pythonp,
        globalTitles: {
            header: {
                logo: "/Logo.png",
                title: "NPN Training",
                courseTitle: "Comprehensive Python Programming",
            },
            socialHandles: [{
                    id: "youtube",
                    url: "https://www.youtube.com/npntraining",
                    icon: FaYoutube,
                }, {
                    id: "linkedIn",
                    url: "https://www.linkedin.com/NPNTraining",
                    icon: FaLinkedin,
                }, {
                    id: "googlemeet",
                    url: "https://meet.google.com/uux-tpip-xqt",
                    icon: FaVideo,
                }, {
                    id: "code",
                    url: "https://codeshare.io/npntraining",
                    icon: FaCode,
                },
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} NPN Training PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by NPN Training",
            },
        },
    },
    1: {
        homePage:
        "https://docs.google.com/document/d/e/2PACX-1vRw2tdvwW_ZjY0Zt-qSos1Vhzm23hpwo7cNfcrp88LUK91tEUkmyan9CdJxcwMMkJoYxaE1fZIPIAmT/pub?embedded=true",
       
        plannerPage: "",
        
        courseWelcomePage:
        "https://docs.google.com/spreadsheets/d/1niPtHpF6u49iU__War8Zntm9_z930_76BQo7DpApxXY/edit?rm=minimal",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :pythonp,
        globalTitles: {
            header: {
                logo: "/Logo.png",
                title: "NPN Training",
                courseTitle: "Data Engineering",
            },
            socialHandles: [{
                    id: "youtube",
                    url: "https://www.youtube.com/npntraining",
                    icon: FaYoutube,
                }, {
                    id: "linkedIn",
                    url: "https://www.linkedin.com/NPNTraining",
                    icon: FaLinkedin,
                }, {
                    id: "googlemeet",
                    url: "https://meet.google.com/uux-tpip-xqt",
                    icon: FaVideo,
                }, {
                    id: "code",
                    url: "https://codeshare.io/npntraining",
                    icon: FaCode,
                },
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} NPN Training PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by NPN Training",
            },
        },
    },2: {
        homePage:
        "https://docs.google.com/document/d/e/2PACX-1vRw2tdvwW_ZjY0Zt-qSos1Vhzm23hpwo7cNfcrp88LUK91tEUkmyan9CdJxcwMMkJoYxaE1fZIPIAmT/pub?embedded=true",
       
        plannerPage: "",
        
        courseWelcomePage:
        "https://docs.google.com/spreadsheets/d/1niPtHpF6u49iU__War8Zntm9_z930_76BQo7DpApxXY/edit?rm=minimal",
        expiryDate: "12/30/2026",
        data :ai_engineering,
        globalTitles: {
            header: {
                logo: "/Logo.png",
                title: "NPN Training",
                courseTitle: "AI Engineering: From Generative AI to Agentic Systems",
            },
            socialHandles: [{
                    id: "youtube",
                    url: "https://www.youtube.com/npntraining",
                    icon: FaYoutube,
                }, {
                    id: "linkedIn",
                    url: "https://www.linkedin.com/NPNTraining",
                    icon: FaLinkedin,
                }, {
                    id: "googlemeet",
                    url: "https://meet.google.com/uux-tpip-xqt",
                    icon: FaVideo,
                }, {
                    id: "code",
                    url: "https://codeshare.io/npntraining",
                    icon: FaCode,
                },
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} NPN Training PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by NPN Training",
            },
        },
    },
};
